export const ELPLAN_BID_REFRESH_EVENT_QUERY_KEY = 'elplan_bid_refresh_token'
export const ELPLAN_BID_WRITE_MUTATION_KEY = 'elplan_bid_write'
export const ELPLAN_REFRESH_EVENT_QUERY_KEY = 'elplan_refresh_token'
export const LATEST_BID_SUBMISSIONS_QUERY_KEY = 'latestBidSubmissions'
export const LATEST_INTRADAY_BATCH_ID_QUERY_KEY = 'latestIntradayBatchId'
